var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBgUserDisp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "visual",
    viewBox: "0 0 900 600",
    width: 900,
    height: 600,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 900,
    height: 600,
    fill: "#002233"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 455L21.5 459.2C43 463.3 86 471.7 128.8 471.3C171.7 471 214.3 462 257.2 456C300 450 343 447 385.8 456.7C428.7 466.3 471.3 488.7 514.2 478.3C557 468 600 425 642.8 404.5C685.7 384 728.3 386 771.2 403.2C814 420.3 857 452.7 878.5 468.8L900 485L900 601L878.5 601C857 601 814 601 771.2 601C728.3 601 685.7 601 642.8 601C600 601 557 601 514.2 601C471.3 601 428.7 601 385.8 601C343 601 300 601 257.2 601C214.3 601 171.7 601 128.8 601C86 601 43 601 21.5 601L0 601Z",
    fill: "#6A64F1",
    strokeLinecap: "round",
    strokeLinejoin: "miter"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgUserDisp);
export default __webpack_public_path__ + "static/media/bg-user-disp.b0a8d2972e9a4da9d8041aea05efd486.svg";
export { ForwardRef as ReactComponent };